// app/javascript/controllers/back_to_top_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { threshold: { type: Number, default: 300 } }

  connect() {
    this.boundCheckScroll = this.checkScroll.bind(this)
    this.boundScrollToTop = this.scrollToTop.bind(this)
    this.isVisible = false
    this.scrollTimeout = null

    // Throttle scroll events to reduce reflows
    window.addEventListener('scroll', () => {
      if (this.scrollTimeout) return
      this.scrollTimeout = requestAnimationFrame(() => {
        this.checkScroll()
        this.scrollTimeout = null
      })
    }, { passive: true })

    // Listen for click events
    this.element.addEventListener('click', this.boundScrollToTop)

    // Initial check
    this.checkScroll()
  }

  disconnect() {
    if (this.scrollTimeout) {
      cancelAnimationFrame(this.scrollTimeout)
    }
    this.element.removeEventListener('click', this.boundScrollToTop)
  }

  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop
    const shouldShow = scrollPosition > this.thresholdValue

    // Only update if state changed to prevent unnecessary DOM queries
    if (shouldShow && !this.isVisible) {
      this.show()
    } else if (!shouldShow && this.isVisible) {
      this.hide()
    }
  }

  show() {
    this.isVisible = true
    this.element.classList.remove('hidden')

    // Use requestAnimationFrame to batch DOM writes
    requestAnimationFrame(() => {
      this.element.style.transform = 'scale(1)'
      this.element.style.opacity = '1'
    })
  }

  hide() {
    this.isVisible = false
    // Add exit animation
    this.element.style.transform = 'scale(0.8)'
    this.element.style.opacity = '0'

    setTimeout(() => {
      this.element.classList.add('hidden')
    }, 200)
  }

  scrollToTop(event) {
    event.preventDefault()
    
    // Add click animation
    this.element.style.transform = 'scale(0.95)'
    
    setTimeout(() => {
      this.element.style.transform = 'scale(1)'
    }, 150)

    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
}